import Root from './src/Root';
import './src/css/main.scss';

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = Root;
